import React from 'react';
import {
  createColumnText,
  createColumnPopover,
  widthOptions,
} from '../../../../components/table/function/createColumn';
import { color, Icon } from '../../../../resources';
import { Checkbox } from 'antd';
import { claimInfoColumns, createClaimStatusColumns } from '../../shared/claimColumns';
import { stockAvailabilityColumn } from '../../shared/stockAvailabilityColumn';
import { approvalStockRecord } from '../../shared/approvalStock';

export const columns = ({
  onReject = () => {},
  isMobile = false,
  selectedClaimIds = [],
  onToggleSelect = () => {},
  onShowHistory = () => undefined,
  stockMap = {},
  selectedByItem = {},
} = {}) => {
  const { claimStatusColumn, processStatusColumn } = createClaimStatusColumns();

  const cols = [
    {
      title: 'สถานะ',
      dataIndex: 'claimStatusName',
      align: 'center',
      width: 200,
      skipExport: true,
      render: (_, record) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          {claimStatusColumn.render(_, record)}
          {processStatusColumn.render(_, record)}
        </div>
      ),
    },
    stockAvailabilityColumn(stockMap, selectedByItem, {
      getStockRecord: approvalStockRecord,
      showFilters: false,
    }),
    ...claimInfoColumns({ onShowHistory }),
    createColumnText('สาเหตุการเคลม', 'breakdownName', widthOptions(190)),
    createColumnPopover({
      title: 'จัดการ',
      dataIndex: 'rowNo',
      options: widthOptions(80, { fixed: 'right' }),
      contentOptions: {
        menuItems: [
          {
            icon: Icon.cancel,
            text: 'ไม่อนุมัติ',
            color: color.red2,
            onClick: (record) => onReject(record),
          },
        ],
      },
    }),
  ];

  if (isMobile) {
    cols.unshift({
      title: 'เลือก',
      dataIndex: 'claimId',
      align: 'center',
      skipExport: true,
      render: (claimId) => (
        <Checkbox
          checked={selectedClaimIds.includes(claimId)}
          onChange={() => onToggleSelect(claimId)}
        />
      ),
    });
  }

  return cols;
};
